var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{directives:[{name:"b-tooltip",rawName:"v-b-tooltip"}],staticClass:"log-icon-info tooltip-info ml-1",attrs:{"title":_vm.$t(("opportunities.details.tooltips." + (_vm.info.toLowerCase())))}})}
var staticRenderFns = []

export { render, staticRenderFns }